module.exports = __webpack_public_path__ + "img/avatar0.736e7529.png";